<template>
    <div class="sb-lounge-product-card" data-test="sb-lounge-product-card">
        <UiProductsCardsLoungeProductCard v-editable="blok" :blok="blok" />
    </div>
</template>

<script lang="ts" setup>
import type { ILoungeProductCard } from '@nuxt-monorepo/ui/types/components/ProductsCards/LoungeProductCard';

defineProps<{
    blok: ILoungeProductCard;
}>();
</script>

<style lang="postcss" scoped></style>
